import { ReactComponent as Svg401 } from '../../assets/401.svg.js';
import { createAssetComponent } from './StyledAsset.js';

const FourZeroOneSvg = createAssetComponent(Svg401, 'FourZeroOneSvg');

export { FourZeroOneSvg };
